import {
  FETCH_NOTIFICATIONS_BEGIN,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  ARCHIVE_NOTIFICATION_BEGIN,
  ARCHIVE_NOTIFICATION_SUCCESS,
  ARCHIVE_NOTIFICATION_FAILURE
} from "./actions"

const initialState = {
  loading: false,
  all: [],
  allCounter: 0,
  read: [],
  readCounter: 0,
  unread: [],
  unreadCounter: 0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_BEGIN:
      return { ...state, loading: true }
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        all: action.payload.notifications.all.results,
        allCounter: action.payload.notifications.all.count,
        read: action.payload.notifications.read.results,
        readCounter: action.payload.notifications.read.count,
        unread: action.payload.notifications.unread.results,
        unreadCounter: action.payload.notifications.unread.count
      }
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false
      }

    case ARCHIVE_NOTIFICATION_BEGIN:
      return { ...state, loading: true }
    case ARCHIVE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case ARCHIVE_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false
      }

    default:
      return state
  }
}
